var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82573 12.3708L8 5.93011L14.1743 12.3708C14.6611 12.9309 15.148 12.9426 15.6349 12.4058C16.1217 11.8691 16.1217 11.344 15.6349 10.8307L8.73029 3.54984C8.55325 3.31648 8.30982 3.1998 8 3.1998C7.69018 3.1998 7.44675 3.31648 7.26971 3.54984L0.365146 10.8307C-0.121716 11.344 -0.121716 11.8691 0.365146 12.4058C0.852005 12.9426 1.33887 12.9309 1.82573 12.3708Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.037f3e561285a0507e8f9c7c38dc814d.svg";
export { ForwardRef as ReactComponent };